<template>
  <div class="report-card">
    <div class="doctor-info">
      <div class="doctor-details">
        <div class="doctor-col">
          <div class="doctor-row-item">
            <span class="doctor-row-label">Patient name: </span>
            <span class="doctor-row-value text-bold">
               {{ reportInfo.patientName }}
            </span>
          </div>
          <div class="doctor-row-item">
            <span class="doctor-row-label">Patient DOB: </span>
            <span class="doctor-row-value">
                {{ reportInfo.patientDob }}
            </span>
          </div>
        </div>
        <div class="doctor-col">
          <div class="doctor-row-item">
            <span class="doctor-row-label">Lab Name: </span>
            <span class="doctor-row-value">{{ reportInfo.labName }}</span>
          </div>
          <div class="doctor-row-item d-flex align-center">
            <div class="doctor-row-sub-item mr-4">
              <span class="doctor-row-label" style="color: #1A202C">Collected: </span>
              <span class="doctor-row-value">{{ reportInfo.dateCollected }}</span>
            </div>
            <div class="doctor-row-sub-item">
              <span class="doctor-row-label">Fasting: </span>
              <span class="doctor-row-value">{{ reportInfo.fasting }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <BloodMarkersTable
        :headers="headers"
        :markersData="markersData"
        :expandedRows="expandedRows"
        :disableToggle="true"
        isReadOnly
        @toggle-group="$emit('toggle-group', $event)"
      />
    </div>
    <div
      v-if="showActions && markersData && markersData.length"
      class="report-actions-footer"
    >
      <Button @click="$emit('download', reportInfo)">
        <DownloadIcon />
      </Button>
      <Button @click="$emit('print', reportInfo.id)">
        <PrintIcon />
      </Button>
      <Button v-if="patient?.email" @click="$emit('email', reportInfo)">
        <EmailIcon />
      </Button>
    </div>
  </div>
</template>

<script>
import BloodMarkersTable from '@/components/layouts/blood/BloodMarkersTable.vue'
import DownloadIcon from '@/assets/icons/components/download-black.svg'
import PrintIcon from '@/assets/icons/components/print-black.svg'
import EmailIcon from '@/assets/icons/components/email-black.svg'
import Button from "@/components/elements/Button.vue";

export default {
  name: 'BloodImportReportPreview',
  components: {Button, BloodMarkersTable, DownloadIcon, PrintIcon, EmailIcon },
  props: {
    reportInfo: Object,
    patient: Object,
    markersData: Array,
    headers: Array,
    expandedRows: Array,
    showActions: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.report-card {
  width: 100%;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background-color: #EBF2FA;
  border-radius: 0 0 8px 8px;
  padding: 12px 10px 85px;
  overflow: hidden;

  .doctor-info {
    display: flex;
    column-gap: 23px;
    flex: 0 0 auto;
    padding: 0 10px 15px 5px;
  }

  .doctor-details {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    column-gap: 54px;

    .doctor-col {
      display: flex;
      flex-direction: column;
      row-gap: 2px;

      .doctor-name {
        color: #1A202C;
        font-weight: 600;
      }
    }

    .doctor-row-item {
      color: #1A202C;
      font-size: 14px;
      font-weight: 400;
      line-height: 23px;
      letter-spacing: 0px;

      .doctor-row-label {
        color: #718096;
      }

      .doctor-row-value.text-bold {
        font-weight: 600;
      }
    }
  }

  .table-wrapper {
    flex: 1 1 auto;
    min-height: 0;

    overflow-y: auto;
    border-radius: 0;
    padding-right: 6px;
    background-clip: content-box;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background-color: #EBF2FA;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cbd5e0;
      border-radius: 10px;
      border: none;
    }
  }

  .report-actions-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    column-gap: 10px;
    background-color: #E4ECF7;
    padding: 10px 15px;
    z-index: 2;

    .button {
      width: 32px;
      height: 32px;
    }

    ::v-deep .v-btn {
      width: 100%;
      height: 100%;
      min-width: 32px;
      background-color: #F7FAFC !important;
      border-radius: 10px;
      padding: 0;

      &:hover {
        background-color: #F7FAFC !important;
      }
    }
  }
}
</style>
